const STORAGE_KEYS = {
  DASHBOARDS: 'ann_db_dashboards',
  SECTIONS: 'ann_db_sections',
  WIDGET_LIBRARY: 'ann_db_widget_library',
  TEMPLATE_CATEGORIES: 'ann_db_template_categories',
  TEMPLATES: 'ann_db_templates',
};

const SEED_DASHBOARDS = [
  {
    id: 'dash-001',
    title: 'Sales Overview Dashboard',
    description:
      'Key metrics for the sales team including pipeline and conversion rates. This comprehensive dashboard tracks quarterly performance, lead quality, and team productivity across all regions.',
    state: 'published',
    sectionId: 'ucp-overview',
    sectionPath: 'Contacts / UCP / Overview',
    creatorId: 'usr-001',
    creatorName: 'David Kim',
    creatorAvatar: null,
    widgetCount: 2,
    tags: ['Sales', 'Pipeline', 'KPI', 'Monthly', 'Forecast', 'Revenue', 'Quarterly'],
    sharedWith: [
      { type: 'user', id: 'usr-002', name: 'Maria Garcia', permissions: ['view'] },
      { type: 'department', id: 'dept-001', name: 'Sales Team', permissions: ['edit'] },
    ],
    widgets: [
      {
        instanceId: 'dash-001_notes_0',
        widgetType: 'notes',
        widgetClass: 'CLASS_2_STANDARD',
        name: 'Team Notes',
        description: 'Internal team notes for this contact',
        actions: ['add'],
        locked: false,
        layout: { i: 'dash-001_notes_0', x: 0, y: 0, w: 4, h: 7 },
      },
      {
        instanceId: 'dash-001_activity_1',
        widgetType: 'activity',
        widgetClass: 'CLASS_2_STANDARD',
        name: 'Recent Activity',
        description: 'Calls, emails, and interactions',
        actions: [],
        locked: true,
        layout: { i: 'dash-001_activity_1', x: 4, y: 0, w: 8, h: 7 },
      },
    ],
    createdAt: '2026-02-15T10:30:00Z',
    updatedAt: '2026-03-10T14:22:00Z',
  },
  {
    id: 'dash-002',
    title: 'Contact Intelligence',
    description:
      'AI-powered insights and recommendations for contact engagement. Combines machine learning models with historical interaction data to suggest optimal outreach timing and personalized messaging strategies.',
    state: 'draft',
    sectionId: 'ucp-intelligence',
    sectionPath: 'Contacts / UCP / Intelligence',
    creatorId: 'usr-002',
    creatorName: 'Maria Garcia',
    creatorAvatar: null,
    widgetCount: 1,
    tags: ['Intelligence', 'AI', 'Recommendations'],
    sharedWith: [],
    widgets: [
      {
        instanceId: 'dash-002_appointments_0',
        widgetType: 'appointments',
        widgetClass: 'CLASS_1_COMPACT',
        name: 'Upcoming Appointments',
        description: 'Scheduled meetings and follow-ups',
        actions: [],
        locked: false,
        layout: { i: 'dash-002_appointments_0', x: 0, y: 0, w: 4, h: 5 },
      },
    ],
    createdAt: '2026-03-01T09:00:00Z',
    updatedAt: '2026-03-11T16:45:00Z',
  },
  {
    id: 'dash-003',
    title: 'Marketing Campaign Tracker',
    description:
      'Monitor campaign performance, ad spend, and ROI across all channels. Includes real-time metrics for email, social, and paid campaigns.',
    state: 'published',
    sectionId: 'ucp-overview',
    sectionPath: 'Contacts / UCP / Overview',
    creatorId: 'usr-003',
    creatorName: 'Carlos Ruiz',
    creatorAvatar: null,
    widgetCount: 4,
    tags: ['Marketing', 'Campaigns', 'Analytics'],
    sharedWith: [
      { type: 'department', id: 'dept-002', name: 'Marketing', permissions: ['view', 'edit'] },
    ],
    widgets: [],
    createdAt: '2026-02-20T08:15:00Z',
    updatedAt: '2026-03-09T11:30:00Z',
  },
  {
    id: 'dash-004',
    title: 'Customer Support Overview',
    description:
      'Track support tickets, response times, and customer satisfaction scores. Essential for support team leads and quality assurance.',
    state: 'draft',
    sectionId: 'ucp-overview',
    sectionPath: 'Contacts / UCP / Overview',
    creatorId: 'usr-001',
    creatorName: 'David Kim',
    creatorAvatar: null,
    widgetCount: 3,
    tags: ['Support', 'Tickets', 'CSAT'],
    sharedWith: [],
    widgets: [],
    createdAt: '2026-03-05T14:00:00Z',
    updatedAt: '2026-03-12T09:20:00Z',
  },
  {
    id: 'dash-005',
    title: 'Executive Summary',
    description:
      'High-level KPIs and financial metrics for leadership. Consolidates data from sales, marketing, and operations into a single view.',
    state: 'published',
    sectionId: 'ucp-intelligence',
    sectionPath: 'Contacts / UCP / Intelligence',
    creatorId: 'usr-002',
    creatorName: 'Maria Garcia',
    creatorAvatar: null,
    widgetCount: 6,
    tags: ['Executive', 'KPI', 'Finance', 'Summary'],
    sharedWith: [{ type: 'user', id: 'usr-004', name: 'Ana Lopez', permissions: ['view'] }],
    widgets: [],
    createdAt: '2026-01-10T09:00:00Z',
    updatedAt: '2026-03-11T17:00:00Z',
  },
  {
    id: 'dash-006',
    title: 'Product Analytics',
    description:
      'User engagement, feature adoption, and product usage metrics. Helps product teams make data-driven decisions.',
    state: 'draft',
    sectionId: 'ucp-overview',
    sectionPath: 'Contacts / UCP / Overview',
    creatorId: 'usr-003',
    creatorName: 'Carlos Ruiz',
    creatorAvatar: null,
    widgetCount: 5,
    tags: ['Product', 'Analytics', 'Engagement'],
    sharedWith: [],
    widgets: [],
    createdAt: '2026-03-08T10:00:00Z',
    updatedAt: '2026-03-12T08:15:00Z',
  },
  {
    id: 'dash-007',
    title: 'HR & Onboarding',
    description:
      'New hire progress, training completion, and team headcount. Central hub for HR and people operations.',
    state: 'published',
    sectionId: 'ucp-intelligence',
    sectionPath: 'Contacts / UCP / Intelligence',
    creatorId: 'usr-004',
    creatorName: 'Ana Lopez',
    creatorAvatar: null,
    widgetCount: 2,
    tags: ['HR', 'Onboarding', 'People'],
    sharedWith: [
      { type: 'department', id: 'dept-003', name: 'People Ops', permissions: ['view', 'edit'] },
    ],
    widgets: [],
    createdAt: '2026-02-28T16:30:00Z',
    updatedAt: '2026-03-10T12:00:00Z',
  },
];

const SEED_SECTIONS = [
  {
    id: 'home',
    name: 'Home',
    icon: 'home',
    supportsDashboard: false,
    children: [{ id: 'home-overview', name: 'Overview', supportsDashboard: true }],
  },
  {
    id: 'agents',
    name: 'Agents',
    icon: 'aiChat',
    supportsDashboard: false,
    children: [],
  },
  {
    id: 'automation',
    name: 'Automation',
    icon: 'bolt',
    supportsDashboard: false,
    children: [],
  },
  {
    id: 'data',
    name: 'Data',
    icon: 'data_table',
    supportsDashboard: false,
    children: [],
  },
  {
    id: 'contacts',
    name: 'Contacts',
    icon: 'person',
    supportsDashboard: false,
    children: [
      {
        id: 'contacts-ucp',
        name: 'UCP',
        supportsDashboard: false,
        children: [
          { id: 'ucp-overview', name: 'Overview', supportsDashboard: true },
          { id: 'ucp-intelligence', name: 'Intelligence', supportsDashboard: true },
        ],
      },
      {
        id: 'contacts-intelligence',
        name: 'Intelligence',
        supportsDashboard: false,
        children: [],
      },
    ],
  },
  {
    id: 'admin',
    name: 'Admin',
    icon: 'shield',
    supportsDashboard: false,
    children: [],
  },
  {
    id: 'workspace',
    name: 'Workspace',
    icon: 'domain',
    supportsDashboard: false,
    children: [{ id: 'workspace-overview', name: 'Overview', supportsDashboard: true }],
  },
];

const SEED_WIDGET_LIBRARY = [
  {
    id: 'widget-notes',
    name: 'Notes',
    type: 'notes',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'notes',
    category: 'Communication',
    description: 'Display and manage notes for the current context.',
    bestFor:
      'Keeping track of important observations, follow-ups, and internal notes about contacts',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'medium',
    defaultActions: ['add'],
  },
  {
    id: 'widget-activity',
    name: 'Activity Feed',
    type: 'activity',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'activityFeed',
    category: 'Communication',
    description: 'View recent calls, emails, and interactions.',
    bestFor: 'Tracking recent interactions and events, monitoring team activity in real-time',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'large',
    defaultActions: [],
  },
  {
    id: 'widget-emails',
    name: 'Emails',
    type: 'emails',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'mail',
    category: 'Communication',
    description: 'View and manage email conversations linked to the current contact.',
    bestFor: 'Centralizing email threads and keeping communication history accessible',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'medium',
    defaultActions: [],
  },
  {
    id: 'widget-chat',
    name: 'Chat Messages',
    type: 'chat',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'chat',
    category: 'Communication',
    description: 'Real-time chat messages and conversation threads.',
    bestFor: 'Monitoring live conversations and quick internal messaging',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['medium', 'large'],
    defaultSize: 'medium',
    defaultActions: [],
  },
  {
    id: 'widget-appointments',
    name: 'Appointments',
    type: 'appointments',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'calendarToday',
    category: 'Scheduling',
    description: 'Upcoming and past appointments for the current context.',
    bestFor: 'Scheduling oversight and ensuring no meetings are missed',
    widgetClass: 'CLASS_1_COMPACT',
    previewImage: null,
    sizes: ['small', 'medium'],
    defaultSize: 'small',
    defaultActions: [],
  },
  {
    id: 'widget-tasks',
    name: 'Tasks',
    type: 'tasks',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'checkCircle',
    category: 'Scheduling',
    description: 'Track pending, in-progress, and completed tasks.',
    bestFor: 'Organizing daily work, assigning responsibilities, and tracking completion',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'medium',
    defaultActions: ['add'],
  },
  {
    id: 'widget-follow-ups',
    name: 'Follow-ups',
    type: 'followUps',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'schedule',
    category: 'Scheduling',
    description: 'Scheduled follow-ups and reminders for contacts.',
    bestFor: 'Never missing a follow-up and staying on top of outreach cadences',
    widgetClass: 'CLASS_1_COMPACT',
    previewImage: null,
    sizes: ['small', 'medium'],
    defaultSize: 'small',
    defaultActions: ['add'],
  },
  {
    id: 'widget-pipeline',
    name: 'Pipeline Overview',
    type: 'pipeline',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'barChart',
    category: 'Analytics',
    description: 'Visualize deal stages, values, and progression through the sales pipeline.',
    bestFor: 'Understanding deal flow, identifying bottlenecks, and forecasting revenue',
    widgetClass: 'CLASS_3_FULL',
    previewImage: null,
    sizes: ['medium', 'large'],
    defaultSize: 'large',
    defaultActions: [],
  },
  {
    id: 'widget-conversion-funnel',
    name: 'Conversion Funnel',
    type: 'conversionFunnel',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'filterList',
    category: 'Analytics',
    description: 'Track conversion rates across each stage of the customer journey.',
    bestFor: 'Identifying drop-off points and optimizing the lead-to-customer path',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['medium', 'large'],
    defaultSize: 'medium',
    defaultActions: [],
  },
  {
    id: 'widget-performance-score',
    name: 'Performance Score',
    type: 'performanceScore',
    provider: 'ANN Core',
    providerIcon: null,
    icon: 'speed',
    category: 'Analytics',
    description: 'Aggregated performance metrics with trend indicators and benchmarks.',
    bestFor: 'Quick health-check on KPIs and comparing against team or historical targets',
    widgetClass: 'CLASS_1_COMPACT',
    previewImage: null,
    sizes: ['small', 'medium'],
    defaultSize: 'small',
    defaultActions: [],
  },
  {
    id: 'widget-ai-insights',
    name: 'AI Insights',
    type: 'aiInsights',
    provider: 'ANN Intelligence',
    providerIcon: null,
    icon: 'aiChat',
    category: 'Intelligence',
    description: 'AI-generated recommendations and actionable insights for contacts.',
    bestFor:
      'Surfacing hidden opportunities, risk signals, and next-best-action suggestions',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['medium', 'large'],
    defaultSize: 'medium',
    defaultActions: [],
  },
  {
    id: 'widget-sentiment',
    name: 'Sentiment Analysis',
    type: 'sentiment',
    provider: 'ANN Intelligence',
    providerIcon: null,
    icon: 'trendingUp',
    category: 'Intelligence',
    description: 'Analyze communication tone and customer sentiment over time.',
    bestFor:
      'Detecting shifts in customer satisfaction and proactively addressing concerns',
    widgetClass: 'CLASS_2_STANDARD',
    previewImage: null,
    sizes: ['small', 'medium', 'large'],
    defaultSize: 'medium',
    defaultActions: [],
  },
];

const SEED_TEMPLATE_CATEGORIES = [
  { id: 'sales', name: 'Sales' },
  { id: 'performance', name: 'Performance' },
  { id: 'operations', name: 'Operations' },
  { id: 'support', name: 'Support' },
];

const SEED_TEMPLATES = [
  {
    id: 'template-ucp-overview',
    title: 'UCP Overview',
    description:
      'Provide a detailed illustration of the performance metrics for a client, including key indicators such as revenue and churn rates.',
    widgetCount: 8,
    previewImage: null,
    tags: ['UCP', 'Sales', 'Risk', 'Service', 'Churn'],
    sectionPath: 'Contacts / UCP',
    categoryId: 'performance',
  },
  {
    id: 'template-ucp-intelligence',
    title: 'UCP Intelligence',
    description:
      'Discover valuable insights from your clients through advanced AI technology. This data offers a deeper understanding of client behavior.',
    widgetCount: 8,
    previewImage: null,
    tags: ['UCP', 'Sales', 'Risk', 'Service', 'Churn'],
    sectionPath: 'Contacts / UCP',
    categoryId: 'performance',
  },
  {
    id: 'template-home-dashboard',
    title: 'Home Dashboard',
    description:
      'Find key information summarizing the most relevant updates. These insights will help you make informed decisions by highlighting trends.',
    widgetCount: 4,
    previewImage: null,
    tags: ['UCP', 'Sales', 'Risk', 'Service', 'Churn'],
    sectionPath: 'Home',
    categoryId: 'operations',
  },
  {
    id: 'template-sales-performance',
    title: 'Sales Performance',
    description: 'Pre-configured dashboard for sales teams with pipeline widgets.',
    widgetCount: 4,
    previewImage: null,
    tags: ['Sales', 'Performance'],
    categoryId: 'sales',
  },
];

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const clone = (value) => JSON.parse(JSON.stringify(value));

const readLocalStorage = (key) => {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    console.warn(`dashboardBuilderMockAdapter: failed reading ${key}`, error);
    return null;
  }
};

const writeLocalStorage = (key, value) => {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`dashboardBuilderMockAdapter: failed writing ${key}`, error);
  }
};

const createStore = (storageKey, seedData) => ({
  read() {
    const local = readLocalStorage(storageKey);
    if (local) return local;
    const seeded = clone(seedData);
    writeLocalStorage(storageKey, seeded);
    return seeded;
  },
  write(nextValue) {
    writeLocalStorage(storageKey, nextValue);
  },
});

export const createDashboardBuilderMockAdapter = ({
  dashboardsSeed = SEED_DASHBOARDS,
  sectionsSeed = SEED_SECTIONS,
  widgetLibrarySeed = SEED_WIDGET_LIBRARY,
  templateCategoriesSeed = SEED_TEMPLATE_CATEGORIES,
  templatesSeed = SEED_TEMPLATES,
} = {}) => {
  const dashboardsStore = createStore(STORAGE_KEYS.DASHBOARDS, dashboardsSeed);
  const sectionsStore = createStore(STORAGE_KEYS.SECTIONS, sectionsSeed);
  const widgetLibraryStore = createStore(STORAGE_KEYS.WIDGET_LIBRARY, widgetLibrarySeed);
  const templateCategoriesStore = createStore(STORAGE_KEYS.TEMPLATE_CATEGORIES, templateCategoriesSeed);
  const templatesStore = createStore(STORAGE_KEYS.TEMPLATES, templatesSeed);

  const findDashboards = (params = {}) => {
    let filtered = dashboardsStore.read();

    if (params.search) {
      const keyword = String(params.search).toLowerCase();
      filtered = filtered.filter(
        (d) =>
          String(d.title || '')
            .toLowerCase()
            .includes(keyword) ||
          String(d.description || '')
            .toLowerCase()
            .includes(keyword)
      );
    }
    if (params.state) {
      filtered = filtered.filter((d) => d.state === params.state);
    }
    if (params.sectionId) {
      filtered = filtered.filter((d) => d.sectionId === params.sectionId);
    }

    filtered = [...filtered].sort((a, b) => {
      const isAArchived = a?.state === 'archived';
      const isBArchived = b?.state === 'archived';

      if (isAArchived !== isBArchived) {
        return isAArchived ? 1 : -1;
      }

      const aCreatedAt = Date.parse(a?.createdAt || 0);
      const bCreatedAt = Date.parse(b?.createdAt || 0);
      return bCreatedAt - aCreatedAt;
    });

    return clone(filtered);
  };

  const findDashboardById = (id) => dashboardsStore.read().find((d) => d.id === id) || null;

  const insertDashboard = (data = {}) => {
    const list = dashboardsStore.read();
    const widgets = Array.isArray(data.widgets) ? data.widgets : [];
    const sharedWith = Array.isArray(data.sharedWith) ? data.sharedWith : [];
    const nextDashboard = {
      id: `dash-${Date.now()}`,
      title: data.title || 'Untitled Dashboard',
      description: data.description || '',
      state: data.state || 'draft',
      sectionId: data.sectionId || null,
      sectionPath: data.sectionPath || '',
      creatorId: data.creatorId || null,
      creatorName: data.creatorName || null,
      creatorAvatar: data.creatorAvatar || null,
      widgetCount: widgets.length,
      tags: Array.isArray(data.tags) ? data.tags : [],
      sharedWith,
      widgets,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    list.push(nextDashboard);
    dashboardsStore.write(list);
    return clone(nextDashboard);
  };

  const duplicateDashboard = (id) => {
    const dashboard = findDashboardById(id);
    if (!dashboard) return null;

    return insertDashboard({
      ...dashboard,
      title: `${dashboard.title || 'Untitled Dashboard'} Copy`,
      state: 'draft',
      archivedFromState: null,
      sharedWith: [],
    });
  };

  const archiveDashboard = (id) => {
    const dashboard = findDashboardById(id);
    if (!dashboard) return null;

    const previousState = dashboard.state === 'archived'
      ? dashboard.archivedFromState || 'draft'
      : dashboard.state || 'draft';

    return patchDashboard(id, {
      state: 'archived',
      archivedFromState: previousState,
    });
  };

  const unarchiveDashboard = (id) => {
    const dashboard = findDashboardById(id);
    if (!dashboard) return null;

    const restoredState = dashboard.archivedFromState || 'draft';
    return patchDashboard(id, {
      state: restoredState,
      archivedFromState: null,
    });
  };

  const patchDashboard = (id, data = {}) => {
    const list = dashboardsStore.read();
    const index = list.findIndex((d) => d.id === id);
    if (index === -1) return null;

    const nextWidgets = Array.isArray(data.widgets) ? data.widgets : list[index].widgets || [];
    list[index] = {
      ...list[index],
      ...data,
      widgetCount: nextWidgets.length,
      updatedAt: new Date().toISOString(),
    };

    dashboardsStore.write(list);
    return clone(list[index]);
  };

  const removeDashboard = (id) => {
    const list = dashboardsStore.read();
    const index = list.findIndex((d) => d.id === id);
    if (index === -1) return false;
    list.splice(index, 1);
    dashboardsStore.write(list);
    return true;
  };

  const appendDashboardShares = (id, assignments = []) => {
    const list = dashboardsStore.read();
    const index = list.findIndex((d) => d.id === id);
    if (index === -1) return null;
    const currentShared = Array.isArray(list[index].sharedWith) ? list[index].sharedWith : [];
    list[index] = {
      ...list[index],
      sharedWith: [...currentShared, ...(Array.isArray(assignments) ? assignments : [])],
      updatedAt: new Date().toISOString(),
    };
    dashboardsStore.write(list);
    return clone(list[index]);
  };

  const getSections = () => clone(sectionsStore.read());
  const getWidgets = () => clone(widgetLibraryStore.read());
  const getTemplateCategories = () => clone(templateCategoriesStore.read());

  const findTemplates = (params = {}) => {
    let filtered = templatesStore.read();

    if (params.search) {
      const keyword = String(params.search).toLowerCase();
      filtered = filtered.filter(
        (t) =>
          String(t.title || '')
            .toLowerCase()
            .includes(keyword) ||
          String(t.description || '')
            .toLowerCase()
            .includes(keyword) ||
          (Array.isArray(t.tags) ? t.tags : []).some((tag) =>
            String(tag || '')
              .toLowerCase()
              .includes(keyword)
          )
      );
    }
    if (params.sectionId) {
      filtered = filtered.filter((t) => t.sectionId === params.sectionId);
    }
    if (params.categoryId) {
      filtered = filtered.filter((t) => t.categoryId === params.categoryId);
    }

    return clone(filtered);
  };

  return {
    findDashboards,
    findDashboardById,
    insertDashboard,
    duplicateDashboard,
    archiveDashboard,
    unarchiveDashboard,
    patchDashboard,
    removeDashboard,
    appendDashboardShares,
    getSections,
    getWidgets,
    getTemplateCategories,
    findTemplates,
  };
};

